import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode";
import { EntityEnum } from "../../EntityEnum";
import { ATCcodeEntityListView } from "../../../Data/MedicinalProductData/ATCcodeEntityListView";
import { ATCcodeAutoUploadEntity } from "../Entity/ATCcodeAutoUploadEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { BaseNode } from "../../BaseNode";

export class TreeNodeMedicinalProductsATCcode extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new ATCcodeEntityListView(items), 'ATC Codes', useHist ? EntityEnum.atccodeHist : EntityEnum.atccode);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${this.ioc!.get(LookupGetService).retrieveValueFromCache('type_Term', model.type_Term)} - ${model.atccode} - ${model.atccode_Desc}`;
        return this.addChildNode(ATCcodeAutoUploadEntity, labelTemplate, this, model, this.useHist, false, false);
        // add specific nodes for this entity
    }

    override getCriteriaFields(): string[] {
        return ['type_Term', 'atccode', 'atccode_Desc'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for ATCs available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}